(function () {
  if (window.__cartRecBound) return;
  window.__cartRecBound = true;

  // Money format is read lazily from the first .cart-rec[data-money-format] we
  // initialize. The snippet passes shop.money_format through that attribute so
  // this script can live as a static asset (loaded on page load) instead of an
  // inline <script> — inline scripts injected by the AJAX cart drawer's
  // innerHTML never execute, which is why recommendations rendered blank.
  var CARTREC_FMT = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Self-contained money formatter. This store's money_format comes from a
  // currency app — `<span class=trans-money>{{amount_with_dot_separator}}€</span>` —
  // a placeholder the theme's own formatMoney can't handle, so we format here and
  // keep the wrapper span so the currency converter can still localize the amount.
  function money(cents) {
    var fmt = CARTREC_FMT || ('{' + '{amount}' + '}');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(precision, thousands, decimal) {
      var c = (cents == null || isNaN(cents)) ? 0 : cents;
      var parts = (c / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(placeholder), value;
    switch (match && match[1]) {
      case 'amount': value = num(2, ',', '.'); break;
      case 'amount_no_decimals': value = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = num(0, ' ', ''); break;
      case 'amount_with_space_separator': value = num(2, ' ', ','); break;
      case 'amount_with_dot_separator': value = num(2, '', '.'); break;
      default: value = num(2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  function normalizeApi(p) {
    return {
      id: p.id,
      title: p.title,
      url: p.url,
      image: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '',
      variants: (p.variants || []).map(function (v) {
        return { id: v.id, title: v.title, price: v.price, available: v.available !== false };
      })
    };
  }

  function fetchRecs(anchor, intent) {
    return fetch(window.Shopify.routes.root + 'recommendations/products.json?product_id=' + anchor + '&intent=' + intent + '&limit=12')
      .then(function (r) { return r.json(); })
      .then(function (data) { return data.products || []; })
      .catch(function () { return []; });
  }

  function defaultVariant(product) {
    var vs = product.variants || [];
    return vs.filter(function (v) { return v.available; })[0] || vs[0] || null;
  }

  function priceHTML(variant) {
    if (!variant) return '';
    var sale = Math.round(variant.price * 0.9);
    return '<span class="cart-rec__price--sale">' + money(sale) + '</span>'
      + '<s class="cart-rec__price--old">' + money(variant.price) + '</s>';
  }

  function cardHTML(product) {
    var vs = product.variants || [];
    var def = defaultVariant(product);
    var defId = def ? def.id : '';
    var img = product.image
      ? '<img src="' + product.image + '" alt="' + esc(product.title) + '" loading="lazy" width="96" height="96">'
      : '';
    var selectHTML = '';
    if (vs.length > 1) {
      selectHTML = '<select class="cart-rec__variant" aria-label="Variante">'
        + vs.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled')
              + (v.id === defId ? ' selected' : '') + '>' + esc(v.title) + '</option>';
          }).join('')
        + '</select>';
    }
    return '<div class="cart-rec__card">'
      + '<a class="cart-rec__media" href="' + product.url + '" draggable="false">' + img + '</a>'
      + '<div class="cart-rec__info">'
      + '<p class="cart-rec__name">' + esc(product.title) + '</p>'
      + '<p class="cart-rec__price" data-rec-price>' + priceHTML(def) + '</p>'
      + '<div class="cart-rec__actions">' + selectHTML
      + '<button type="button" class="cart-rec__add" data-variant-id="' + defId + '">Hinzufügen</button>'
      + '</div></div></div>';
  }

  function initCarousel(rec) {
    if (rec.dataset.recInit) return;
    rec.dataset.recInit = '1';

    if (!CARTREC_FMT) CARTREC_FMT = rec.getAttribute('data-money-format');

    var products = [];
    try { products = JSON.parse(rec.getAttribute('data-cart-rec') || '[]'); } catch (e) { products = []; }

    var stage = rec.querySelector('.cart-rec__stage');
    var prev = rec.querySelector('.cart-rec__nav--prev');
    var next = rec.querySelector('.cart-rec__nav--next');
    var index = 0;

    function render() {
      if (!products.length) { rec.style.display = 'none'; return; }
      rec.style.display = '';
      if (index < 0) index = products.length - 1;
      if (index >= products.length) index = 0;
      stage.innerHTML = cardHTML(products[index]);
      var multi = products.length > 1;
      prev.hidden = !multi;
      next.hidden = !multi;
    }

    function addToCart(btn) {
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.disabled) return;
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = '…';
      var restore = function () { btn.disabled = false; btn.textContent = label; };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        // cart/add.js returns 422 (sold out / max quantity) with a JSON error
        // body. Without this check the error response is treated as success: the
        // drawer opens as if added and the button hangs disabled on '…'.
        return r.json().then(function (data) {
          if (!r.ok) {
            var err = new Error(data && data.description ? data.description : 'cart/add failed');
            err.cartError = data;
            throw err;
          }
          return data;
        });
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }).catch(function (err) {
        console.error(err);
        restore();
      });
    }

    rec.addEventListener('click', function (e) {
      if (e.target.closest('.cart-rec__nav--prev')) { index -= 1; render(); return; }
      if (e.target.closest('.cart-rec__nav--next')) { index += 1; render(); return; }
      var add = e.target.closest('.cart-rec__add');
      if (add) addToCart(add);
    });

    rec.addEventListener('change', function (e) {
      var sel = e.target.closest('.cart-rec__variant');
      if (!sel) return;
      var product = products[index];
      var v = (product.variants || []).filter(function (x) { return String(x.id) === String(sel.value); })[0];
      if (!v) return;
      var priceEl = rec.querySelector('[data-rec-price]');
      if (priceEl) priceEl.innerHTML = priceHTML(v);
      var addBtn = rec.querySelector('.cart-rec__add');
      if (addBtn) addBtn.setAttribute('data-variant-id', v.id);
    });

    render();

    // Hybrid: prefer complementary ("often bought with"), then algorithmic related,
    // then keep the curated 'empfehlungen' products already rendered. Never goes blank.
    var anchor = rec.getAttribute('data-rec-anchor');
    if (anchor) {
      var inCart = (rec.getAttribute('data-rec-incart') || '').split(',').filter(Boolean).map(Number);
      var usable = function (list) {
        return (list || []).filter(function (p) {
          return p.available && inCart.indexOf(p.id) === -1;
        }).slice(0, 12).map(normalizeApi);
      };
      fetchRecs(anchor, 'complementary').then(function (comp) {
        var u = usable(comp);
        if (u.length) return u;
        return fetchRecs(anchor, 'related').then(usable);
      }).then(function (u) {
        if (!u || !u.length) return; // keep curated fallback
        products = u;
        index = 0;
        render();
      });
    }
  }

  function initAll() { document.querySelectorAll('.cart-rec').forEach(initCarousel); }

  function bindObservers() {
    // Observe the OUTER drawer container too: some Minimog refresh paths (e.g. the
    // cart:refresh fired after adding through this carousel) replace the whole
    // #MinimogCartDrawerBody node, which kills an observer bound to it. The outer
    // #MinimogCartDrawer element survives every refresh path, so watching it with
    // subtree:true reliably catches the freshly rendered .cart-rec.
    ['MinimogCartDrawer', 'MinimogCartDrawerBody', 'MinimogCartDrawerFooter', 'MinimogCartFooter'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) new MutationObserver(initAll).observe(el, { childList: true, subtree: true });
    });
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindObservers);
  } else {
    bindObservers();
  }
})();
